'use client';

import { ThinSheepStrip } from '@/components/redesign/sheep-strip';

/**
 * Thin sheep strip pinned flush above the BottomNav. Drop into any
 * page where the bottom edge would otherwise sit directly on the
 * nav — handles the fixed-positioning + safe-area math + 2px ink
 * top rule so callers stay simple. Veronika 2026-05-11: "At all
 * empty archives add a little sheep stripe down on the page".
 *
 * The spacer div pushes content up by the strip's height + a
 * breathing margin so callers don't have to bump paddingBottom
 * themselves.
 */
export default function PageSheepStrip() {
  return (
    <>
      <div aria-hidden style={{ height: 32 }} />
      <div
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 'var(--bottom-nav-height, 64px)',
          height: 26,
          borderTop: '2px solid var(--ink)',
          background: 'var(--paper-1)',
          overflow: 'hidden',
          zIndex: 30,
        }}
      >
        <ThinSheepStrip />
      </div>
    </>
  );
}
